import InputBase from '@material-ui/core/InputBase';

export default InputBase;
